module.exports = __webpack_public_path__ + "static/img/fish39.db6308c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/flydragonfish/fish39.png
// module id = Wmlv
// module chunks = 0